export default "__VITE_ASSET__684bf271__"